module.exports = __webpack_public_path__ + "static/img/bg-Client-01.9a419beb.png";